import { NavLink, Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button, Menu } from '@mantine/core';
import { cleanNotifications } from '@mantine/notifications';
import { useAuthContext } from '../../context/AuthContext';

import Logo from '../../icons/logo';
import TemplateIcon from '../../icons/template-icon';
import UsersIcon from '../../icons/users-icon';
import CubeIcon from '../../icons/cube-icon';
import SensorIcon from '../../icons/sensor-icon';
import AlertIcon from '../../icons/alert-icon';
import SignOutIcon from '../../icons/sign-out-icon';
import UserIcon from '../../icons/user-icon';
import HelpIcon from '../../icons/help-icon';
import SettingsIcon from '../../icons/settings-icon';

import styles from './Navigation.module.scss';

const Navigation = () => {
  const { t } = useTranslation();
  const { user, logout } = useAuthContext();

  return (
    <nav className={styles.nav}>
      <div className={styles['logo-container']}>
        <NavLink to="dashboard" aria-label="dashboard">
          <Logo />
        </NavLink>
      </div>
      <ul>
        <li>
          <NavLink
            to="dashboard"
            className={({ isActive }) => (isActive ? styles.active : undefined)}
          >
            <TemplateIcon />
            {t('DASHBOARD')}
          </NavLink>
        </li>
        <li>
          <NavLink
            to="clients"
            className={({ isActive }) => (isActive ? styles.active : undefined)}
          >
            <UsersIcon />
            {t('CLIENTS')}
          </NavLink>
        </li>
        <li>
          <NavLink to="hubs" className={({ isActive }) => (isActive ? styles.active : undefined)}>
            <CubeIcon />
            {t('HUBS')}
          </NavLink>
        </li>
        <li>
          <NavLink
            to="sensors"
            className={({ isActive }) => (isActive ? styles.active : undefined)}
          >
            <SensorIcon />
            {t('SENSORS')}
          </NavLink>
        </li>
        <li>
          <NavLink to="alerts" className={({ isActive }) => (isActive ? styles.active : undefined)}>
            <AlertIcon />
            {t('ALERTS')}
          </NavLink>
        </li>
      </ul>

      <Menu
        width={250}
        transitionProps={{ transition: 'scale-y', duration: 200 }}
        shadow="0px 5px 20px #00000019"
        radius={10}
        offset={0}
      >
        <Menu.Target>
          <Button
            variant="transparent"
            leftSection={<UserIcon />}
            className={`${styles['user-button']}`}
          >
            <span className={styles['user-info']}>
              {user && (
                <p className={styles.role}>
                  {t(`common:${user.role.toUpperCase()}`).toUpperCase()}
                </p>
              )}
              {user && (
                <p className={styles.username}>
                  {t('LOGGED_AS')}: {user.login ? user.login : `${user.email}`}
                </p>
              )}
            </span>
          </Button>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Item leftSection={<UserIcon />}>
            <Link to="profile">{t('PROFILE_AND_SETTINGS')}</Link>
          </Menu.Item>
          <Menu.Divider />
          <Menu.Item leftSection={<SettingsIcon />}>
            <Link to="channels">{t('NOTIFICATION_CHANNEL')}</Link>
          </Menu.Item>
          <Menu.Divider />
          <Menu.Item leftSection={<HelpIcon />}>
            <Link to="help">{t('HELP')}</Link>
          </Menu.Item>
          <Menu.Divider />
          <Menu.Item
            leftSection={<SignOutIcon />}
            onClick={() => {
              logout();
              cleanNotifications();
            }}
          >
            <Link to="/login">{t('LOGOUT')}</Link>
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </nav>
  );
};

export default Navigation;
